/**
 * api-v2 failures answer { success: false, errors } (Apiv2\Communicator::toArray()). `errors` is a list,
 * or keyed by field when an input filter rejects a parameter ({ listing_id: ["..."] }). Every message is
 * kept, joined with "; " as json-api joins them; "" when there is none.
 *
 * @param {unknown} errors
 * @returns {string}
 */
const joinApiErrors = errors => {
  if (!errors || typeof errors !== "object") {
    return "";
  }

  return Object.values(errors)
    .flat()
    .filter(message => typeof message === "string" && message.trim())
    .join("; ");
};

/**
 * Message from an axios-style error, safe when the request failed with no response
 * (network drop, timeout, CORS). error.response is undefined in those cases.
 * Reads json-api's `error`, then api-v2's `errors` (GROWTH-7098), then `message`.
 *
 * @param {object} error
 * @param {string} fallback
 * @returns {string}
 */
export const resolveApiErrorMessage = (error, fallback) =>
  error?.response?.data?.error || joinApiErrors(error?.response?.data?.errors) || error?.response?.data?.message || fallback;
